/**
 * CustomerPrivacyApp created to handle privacy related functionality.
 */

// only the init if the customer privacy page is being displayed.
if (WebPageObj.customerPrivacyRequestConfirmation) {
    $(() => {
        CustomerPrivacyRequestConfirmationApp.init();
    });
}

/**
 * Obj to handle the app code.
 *
 * @returns obj
 *
 * @constructor
 */
window.CustomerPrivacyRequestConfirmationApp = function() {
    const confirmationFeedbackPanel = $(".hiddenFeedbackPanel");
    const confirmFormContainer = $("#confirmCPLinkFormContainer");
    const confirmRequestBtn = $("#confirmRequestBtn");
    const requestIdentifierInput = $("#requestIdentifier");
    const pageWaitIndicationContainer = $(".page-wait-indication-container");

    const generalFailureError = "An unexpected error has occurred. Please try again or submit an inquiry to privacy@avasflowers.com, if the problem persists.";

    return {
        /**
         * Initialize the application
         */
        init: function() {
            // Check if email verification link is valid, then set up click handler
            this.checkIfEmailVerificationLinkIsValid(() => {
                confirmRequestBtn.on("click", (e) => {
                    e.preventDefault();
                    this.handleRequestConfirmationForm();
                });
            });
        },

        /**
         * Check if the email verification link is valid
         * @param {Function} callback - To be executed if the link is active
         */
        checkIfEmailVerificationLinkIsValid: function(callback) {
            $.ajax({
                url: "/api/cs_privacy/check_email_verification_link_validity",
                method: "POST",
                data: { requestIdentifier: requestIdentifierInput.val() },
                dataType: "json",
                success: (data) => {
                    pageWaitIndicationContainer.remove();
                    
                    if (data.status) {
                        confirmFormContainer.fadeIn();
                        callback?.();
                    } else {
                        confirmFormContainer.remove();
                        const panelType = data.showInfoBox ? 'info' : 'error';
                        this.displayConfirmationFeedbackPanel(panelType, data.message);
                    }
                },
                error: () => {
                    // Error handling is intentionally empty as per original code
                }
            });
        },

        /**
         * Handle the request confirmation form submission
         */
        handleRequestConfirmationForm: function() {
            const waitMsg = "Please Wait...";
            const originalBtnTxt = confirmRequestBtn.val();

            // Prevent multiple simultaneous requests
            if (confirmRequestBtn.val() === waitMsg) return;

            confirmRequestBtn.val(waitMsg);
            hideFeedbackPanel(confirmationFeedbackPanel);

            $.ajax({
                url: "/api/cs_privacy/confirm_request_verification",
                method: "POST",
                data: { requestIdentifier: requestIdentifierInput.val() },
                dataType: "json",
                success: (data) => {
                    if (data.status) {
                        confirmFormContainer.slideUp();
                        this.displayConfirmationFeedbackPanel('success', data.message);
                    } else {
                        const panelType = data.showInfoBox ? 'info' : 'error';
                        this.displayConfirmationFeedbackPanel(panelType, data.message);
                    }
                    confirmRequestBtn.val(originalBtnTxt);
                },
                error: () => {
                    this.displayConfirmationFeedbackPanel('error', generalFailureError);
                    confirmRequestBtn.val(originalBtnTxt);
                }
            });
        },

        /**
         * Display the feedback panel
         * @param {string} type - The type of feedback: error, success, info
         * @param {string} message - The message to display
         */
        displayConfirmationFeedbackPanel: function(type, message) {
            displayFeedbackPanel(null, confirmationFeedbackPanel, type, message);
        }
    };
}();